import React, { useState, useEffect } from "react";
import investorBanner from "../../assets/images/investorBanner.jpg";
import styles from "./Investor.module.scss";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import { Icon } from "./../../assets/Icons.tsx";
import { Modal } from "react-bootstrap";
// import AgmRecording from "../../assets/videos/25th-AGM-Recording-720.mp4";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { investorOverviewData } from "../../redux/slices/investorSlice.js";
import { motion } from "framer-motion";

interface AccordionAppProps {}
const Investor: React.FC<AccordionAppProps> = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleToggleVisibility = (index: number) => {
    const isBoardAndCommittees =
      accordionData[index]?.tab_details?.name === "Board & Committees";

    if (
      isBoardAndCommittees ||
      accordionData[index]?.tab_details?.contents?.length > 0
    ) {
      setActiveIndex(activeIndex === index ? null : index);
    }
  };
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Investors", link: "/investors" },
    { title: "Overview", link: "/investors" },
  ];

  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const [notifications, setNotifications] = useState([]);
  const [accordionData, setAccordionData] = useState([]);
  const [financials, setFinancials] = useState([]);
  const [shareholdings, setShareholdings] = useState([]);
  const [presentations, setPresentations] = useState([]);
  const [stocks, setStocks] = useState([]);
  const [conducts, setConducts] = useState([]);
  const [policies, setPolicies] = useState([]);
  const [conferences, setConferences] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleMoreClick = () => {
    navigate("/investors/news-and-notifications");
  };
  const handleFinanceMoreClick = () => {
    navigate("/investors/results-and-reports");
  };
  const handleShareholdingMoreClick = () => {
    navigate("/investors/results-and-reports");
  };
  const handlePresentationMoreClick = () => {
    navigate("/investors/presentation");
  };
  const handleStocksMoreClick = () => {
    navigate("/investors/filings-with-stock-exchanges");
  };
  const handleConductsMoreClick = () => {};
  const handlePliciesMoreClick = () => {};
  const handleconferencesMoreClick = () => {
    navigate("/investors/conference-table");
  };
  const navigate = useNavigate();

  const downloadFile = async (fileUrl, fileName) => {
    const url = fileUrl;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch the PDF file.");
      }
      const blob = await response.blob();
      const blobURL = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobURL;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobURL);
    } catch (error) {
      console.error("Error downloading the file:", error);
    }
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const fetchAccordionData = async () => {
      setLoading(true);
      try {
        const data = await dispatch(investorOverviewData()).unwrap();
        setAccordionData(data?.latest_investor_details);
        setLoading(false);

        setNotifications(
          data?.latest_investor_details?.[0]?.tab_details?.contents?.filter(
            (item) => item.status === 1,
          ),
        );
        setFinancials(
          data?.latest_investor_details?.[1]?.tab_details?.contents?.filter(
            (item) => item.file_details.status === 1,
          ),
        );
        setShareholdings(
          data?.latest_investor_details?.[2]?.tab_details?.contents?.filter(
            (item) => item.file_details.status === 1,
          ),
        );

        setConferences(
          data?.latest_investor_details?.[3]?.tab_details?.contents,
        );

        setPresentations(
          data?.latest_investor_details?.[4]?.tab_details?.contents?.filter(
            (item) => item.status === 1,
          ),
        );
        setStocks(
          data?.latest_investor_details?.[5]?.tab_details?.contents?.filter(
            (item) => item.status === 1,
          ),
        );

        setPolicies(
          data?.latest_investor_details?.[8]?.tab_details?.contents?.filter(
            (item) => item.status === 1,
          ),
        );

        setConducts(
          data?.latest_investor_details?.[6]?.tab_details?.contents?.filter(
            (item) => item.status === 1,
          ),
        );
      } catch (error) {
        console.error("Error fetching investor overview data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAccordionData();
  }, [dispatch]);

  const redirectToBoardPage = () => {
    navigate("/investors/board-of-directors");
  };

  return (
    <>
      <BreadCrumb menu={breadcrumb} />
      <div className={`${styles.Investor} mt-3`}>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          <div className="section">
            <div className="container-fluid">
              <div className="row g-0">
                <div className="col-12 position-relative p-0">
                  <img
                    src={investorBanner}
                    alt="investorBanner"
                    className="w-100"
                  />
                  <div className={`${styles.overlay}`}>
                    <h2 className={`heading ${styles.centeredText}`}>
                      A public listed organization revolutionizing
                      <br /> vocational training globally
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          <div className="mb-5">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <p className="heading">Investor Relations</p>
                  <div className={`row ${isMobile ? "g-2" : "g-5"}`}>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <p className="para">
                        Aptech is a global leader in vocational training and
                        skill development, with a strong presence in countries
                        like Vietnam, Egypt, Qatar, Kenya, Malaysia, UAE, Saudi
                        Arabia, and Nigeria. Ever since its inception in 1986,
                        Aptech has diversified its business, offering training
                        across multiple verticals and innovative{" "}
                        <a href="/our-businesses/institutional-business">
                          Assessment and Testing Solutions
                        </a>{" "}
                        to meet industry demands. 
                      </p>
                      <p className="para">
                        At <a href="/">Aptech</a>, we are deeply committed to
                        fostering trust, transparency, and long-term value
                        creation for our{" "}
                        <a href="/investors/shareholders">shareholders</a> and
                        investors. Our goal is to drive sustainable business
                        growth while adapting to emerging trends and
                        opportunities across the education and assessment
                        sectors. 
                      </p>
                    </div>
                    <div className="col-lg-6 col-md-12 col-sm-12">
                      <p className="para">
                        With innovation and operational excellence at its core,
                        Aptech values{" "}
                        <a href="/investors/shareholders">stakeholder</a>{" "}
                        confidence and investor relations, and ensures open
                        communication to achieve shared goals of growth and
                        success. 
                      </p>
                      <p className="para">
                        <strong>
                          Aptech is more than a business – it is a partner in
                          shaping the future, empowering individuals, and
                          driving impactful change across diverse markets. 
                        </strong>
                      </p>
                    </div>
                  </div>
                  {/* <p className="para">
                Aptech is a global leader in vocational training and skill development, with a strong presence in countries like Vietnam, Egypt, Qatar, Kenya, Malaysia, UAE, Saudi Arabia, and Nigeria. Ever since its inception in 1986, Aptech has diversified its business, offering training across multiple verticals and innovative Assessment and Testing Solutions to meet industry demands.
                </p>
                <p className="para">
                  At Aptech, we are deeply committed to fostering trust,
                  transparency, and long-term value creation for our
                  shareholders and investors. Our goal is to drive sustainable
                  business growth while adapting to emerging trends and
                  opportunities across the education and assessment sectors.
                </p>
                <p className="para">
                With innovation and operational excellence at its core, Aptech values stakeholder confidence and investor relations, and ensures open communication to achieve shared goals of growth and success.
                </p>
                <p className="para ">
                  <strong>
                    Aptech is more than a business – it is a partner in shaping
                    the future, empowering individuals, and driving impactful
                    change across diverse markets.
                  </strong>
                </p> */}
                </div>
              </div>
            </div>
          </div>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          <div className="mb-5">
            <div className="container">
              <div className="row">
                <div className="col-12 d-flex align-items-center">
                  <div
                    className={`subHeading caps ${styles.blueText} d-flex align-items-start`}
                  >
                    <span>
                      25th Annual General Meeting Recording{" "}
                      <span onClick={handleOpen} style={{ cursor: "pointer" }}>
                        <Icon
                          name="videoPlayIcon"
                          color="transparent"
                          width="60px"
                          height="60px"
                        />
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal show={showModal} onHide={handleClose} centered>
            <Modal.Body className="p-0">
              <div
                className="video-container d-flex justify-content-center align-items-center"
                style={{ textAlign: "center" }}
              >
                <video width="120%" controls autoPlay>
                  <source
                    src="/videos/25th-AGM-Recording-720.mp4"
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video>
              </div>
            </Modal.Body>
          </Modal>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          <div className="mb-5">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {!loading ? (
                    <div className={styles.accordion}>
                      {accordionData?.map((accordionItem, index) => (
                        <div className={styles.accordionItem}>
                          <AccordionHeader
                            activeIndex={activeIndex}
                            image={accordionItem?.tab_details?.icon_image}
                            title={accordionItem?.tab_details?.name}
                            toggle={() => handleToggleVisibility(index)}
                            index={index}
                          />
                          <AccordionContent
                            activeIndex={activeIndex}
                            index={index}
                          >
                            {accordionItem?.tab_details?.name ===
                              "Investor News" && (
                              <InvestorNewsContent
                                notifications={notifications}
                                downloadFile={downloadFile}
                                handleMoreClick={handleMoreClick}
                              />
                            )}
                            {accordionItem?.tab_details?.name ===
                              "Financials" && (
                              <FinancialsData
                                financials={financials}
                                downloadFile={downloadFile}
                                handleFinanceMoreClick={handleFinanceMoreClick}
                              />
                            )}
                            {accordionItem?.tab_details?.name ===
                              "Shareholding Pattern" && (
                              <ShareholdingsData
                                shareholdings={shareholdings}
                                downloadFile={downloadFile}
                                handleShareholdingMoreClick={
                                  handleShareholdingMoreClick
                                }
                              />
                            )}
                            {accordionItem?.tab_details?.name ===
                              "Conference Call recording And transcript" && (
                              <ConferencesData
                                conferences={conferences}
                                downloadFile={downloadFile}
                                handleconferencesMoreClick={
                                  handleconferencesMoreClick
                                }
                              />
                            )}

                            {accordionItem?.tab_details?.name ===
                              "Investor Presentations" && (
                              <PresentationsData
                                presentations={presentations}
                                downloadFile={downloadFile}
                                handlePresentationMoreClick={
                                  handlePresentationMoreClick
                                }
                              />
                            )}

                            {accordionItem?.tab_details?.name ===
                              "Filing with Stock Exchanges" && (
                              <StockExchangesData
                                stocks={stocks}
                                downloadFile={downloadFile}
                                handleStocksMoreClick={handleStocksMoreClick}
                              />
                            )}

                            {accordionItem?.tab_details?.name ===
                              "Code of Conduct" && (
                              <ConductData
                                conducts={conducts}
                                downloadFile={downloadFile}
                                handleConductsMoreClick={
                                  handleConductsMoreClick
                                }
                              />
                            )}
                            {accordionItem?.tab_details?.name ===
                              "Board & Committees" && (
                              <BoardData
                                redirectToBoardPage={redirectToBoardPage}
                              />
                            )}
                            {accordionItem?.tab_details?.name ===
                              "Policies & Procedures" && (
                              <PoliciesData
                                policies={policies}
                                downloadFile={downloadFile}
                                handlePliciesMoreClick={handlePliciesMoreClick}
                              />
                            )}
                          </AccordionContent>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p className="para text-center">Loading...</p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.5 }} // Triggers animation when 50% of the element is visible
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          <ContactSection />
        </motion.div>
      </div>
    </>
  );
};

export default Investor;

export const ContactSection = () => {
  return (
    <div className={`subSection ${styles.ContactSection}`}>
      <div className="container">
        <div className="row d-flex justify-content-center align-items-stretch">
          <div className="col-lg-8 col-md-12 col-sm-12  mb-4 d-flex">
            <div className={`${styles.card} flex-grow-1`}>
              <div className={`para caps ${styles.headingMain} mb-0`}>
                <strong> Investor contacts</strong>
              </div>
              <div className="row">
                <div className={`col-12`}>
                  <div className={`${styles.cardContent} para`}>
                    <div className="para caps">
                      <strong>Registrar & Share Transfer Agent</strong>
                    </div>
                    <div className={`para mb-0`}>KFIN Technologies Limited</div>
                    <div className="para">
                      Unit: Aptech Limited
                      <br />
                      Selenium Tower B, Plot No. 31 & 32, Financial District,
                      <br />
                      Nanakramguda, Gachibowli, Telangana - 500032, Hyderabad
                    </div>
                    <div className="d-flex align-items-center">
                      <div className={styles.info}>
                        <span className={styles.icon}>
                          <Icon name="phone" color="var(--primary)" />
                        </span>
                        <span className="para mt-0 mb-0">
                          Toll Free No: 1800 309 4001
                        </span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className={styles.info}>
                        <span className={styles.icon}>
                          <Icon name="email" color="var(--primary)" />
                        </span>
                        <span className="para mt-0 mb-0">
                          Email:{" "}
                          <span style={{ color: "#DB6516" }}>
                            <a
                              href="mailto:einward.ris@kfintech.com"
                              style={{
                                color: "#DB6516",
                                textDecoration: "none",
                              }}
                            >
                              einward.ris@kfintech.com
                            </a>
                          </span>
                        </span>
                      </div>
                    </div>
                    <div className="d-flex align-items-center">
                      <div className={styles.info}>
                        <span className={styles.icon}>
                          <Icon name="glob" color="var(--primary)" />
                        </span>
                        <span className="para mt-0 mb-0">
                          Website:{" "}
                          <a
                            href="https://www.kfintech.com/"
                            style={{
                              color: "#DB6516",
                              textDecoration: "none",
                            }}
                          >
                            www.kfintech.com
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row container mt-0">
          <div className="col-12 ">
            <p className="para caps mb-0 text-center">
              <strong>For investor queries & suggestions, email</strong>
            </p>
            <p
              className="blueText para text-center"
              style={{ color: "#DB6516" }}
            >
              <a
                href="mailto:investor_relations@aptech.co.in"
                style={{ color: "#DB6516", textDecoration: "none" }}
              >
                investor_relations@aptech.co.in
              </a>{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const AccordionHeader = ({
  activeIndex,
  image,
  title,
  toggle,
  index,
}) => {
  return (
    <button
      className={`${styles.accordionButton} para`}
      onClick={() => toggle()}
    >
      <div className="d-flex align-items-center">
        <img src={image} alt={title} style={{ width: "40px" }} />
        <div className={`${styles.AccordioncontentText}`}>{title}</div>
      </div>
      <span className={styles.icon}>
        <Icon name={activeIndex === index ? "circleMinus" : "circlePlus"} />
      </span>
    </button>
  );
};

export const AccordionContent = ({ activeIndex, index, children }) => {
  return (
    <div
      className={`${styles.accordionContent} ${
        activeIndex === index ? styles.active : ""
      }`}
    >
      {children}
    </div>
  );
};

const formatDate = (dateString) => {
  if (!dateString) return "Invalid Date"; // Handle empty or undefined dateString

  let date;
  try {
    date = new Date(dateString);
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date");
    }
  } catch {
    return "Invalid Date";
  }

  const day = date.getDate();
  const ordinalSuffix = (day) => {
    if (day > 3 && day < 21) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const options = { month: "long", year: "numeric" };
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(date);

  return (
    <>
      {day}
      <sup>{ordinalSuffix(day)}</sup> {formattedDate}
    </>
  );
};

export const InvestorNewsContent = ({
  notifications,
  downloadFile,
  handleMoreClick,
}) => {
  return (
    <div>
      {notifications && notifications?.length > 0 && (
        <div className={`row ${styles.divBorder}`}>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {notifications
              .slice(0, Math.ceil(notifications?.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex justify-content-start align-items-start">
                    <div style={{ width: "20px" }} className="">
                      <Icon name="pdfIcon" width="20px" />
                    </div>
                    <div>
                      <div className={`para mb-0 ${styles.contentText}`}>
                        <a
                          href={item?.document_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item?.title}{" "}
                        </a>
                        {item?.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(item?.document_path, item?.title)
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-start">
                    <p className={`mb-0 ${styles.date}`}>
                      {formatDate(item?.publish_date)}
                    </p>
                  </div>
                </div>
              ))}
          </div>
          <div className="col-lg-2 col-md-0 com-sm-0 d-flex justify-content-center">
            <div
              className="vertical-line"
              style={{
                width: "1px",
                height: "100%",
                backgroundColor: "#cfcccc",
              }}
            ></div>
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {notifications
              .slice(Math.ceil(notifications?.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex justify-content-start align-items-start">
                    <div style={{ width: "20px" }} className="">
                      <Icon name="pdfIcon" width="20px" />
                    </div>
                    <div>
                      <div
                        className={`blueText para mb-0 ${styles.contentText}`}
                      >
                        <a
                          href={item?.document_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item?.title}{" "}
                        </a>
                        {item?.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(item?.document_path, item?.title)
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-start">
                    <p className={`mb-0 ${styles.date}`}>
                      {formatDate(item?.publish_date)}
                    </p>
                  </div>
                </div>
              ))}
          </div>

          <div className="col-12 d-flex align-items-center justify-content-center">
            <div className="mt-3">
              <button
                className={`secondary-btn ${styles.moreButton}`}
                onClick={handleMoreClick}
              >
                More
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const FinancialsData = ({
  financials,
  downloadFile,
  handleFinanceMoreClick,
}) => {
  return (
    <div>
      {financials && financials?.length > 0 && (
        <div className={`row ${styles.divBorder}`}>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {financials
              .slice(0, Math.ceil(financials?.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex justify-content-start">
                    <p
                      className={`mb-0 para ${styles.date}`}
                      style={{ lineHeight: "30px" }}
                    >
                      {item?.file_details?.file_title} :
                    </p>
                  </div>
                  <div className="d-flex align-items-center">
                    <Icon name="pdfIcon" width="20px" />
                    <div>
                      <div
                        className={`blueText para mb-0  ${styles.contentText}`}
                      >
                        <a
                          href={item?.file_details?.file_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item?.file_details?.file_name}{" "}
                        </a>
                        {item?.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(
                                item?.file_details?.file_path,
                                item?.file_details?.file_name,
                              )
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="col-lg-2 col-md-0 col-sm-0 d-flex justify-content-center">
            <div
              className="vertical-line"
              style={{
                width: "1px",
                height: "100%",
                backgroundColor: "#cfcccc",
              }}
            ></div>
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {financials
              .slice(Math.ceil(financials?.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex justify-content-start">
                    <p
                      className={`mb-0 para ${styles.date}`}
                      style={{ lineHeight: "30px" }}
                    >
                      {item?.file_details?.file_title} :
                    </p>
                  </div>
                  <div className="d-flex align-items-center">
                    <Icon name="pdfIcon" width="20px" />
                    <div>
                      <div
                        className={`blueText para mb-0  ${styles.contentText}`}
                      >
                        <a
                          href={item?.file_details?.file_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item?.file_details?.file_name}{" "}
                        </a>
                        {item?.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(
                                item?.file_details?.file_path,
                                item?.file_details?.file_name,
                              )
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>

          <div className="col-12 d-flex align-items-center justify-content-center">
            <div className="mt-3">
              <button
                className={`secondary-btn ${styles.moreButton}`}
                onClick={handleFinanceMoreClick}
              >
                More
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export const ShareholdingsData = ({
  shareholdings,
  downloadFile,
  handleShareholdingMoreClick,
}) => {
  return (
    <div>
      {shareholdings && shareholdings?.length > 0 && (
        <div className={`row ${styles.divBorder}`}>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {shareholdings
              .slice(0, Math.ceil(shareholdings?.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex justify-content-start">
                    <p
                      className={`mb-0 para ${styles.date}`}
                      style={{ lineHeight: "30px" }}
                    >
                      {item?.file_details?.file_title} :
                    </p>
                  </div>
                  <div className="d-flex align-items-center">
                    <Icon name="pdfIcon" width="20px" />
                    <div>
                      <div
                        className={`blueText para mb-0  ${styles.contentText}`}
                      >
                        <a
                          href={item?.file_details?.file_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item?.file_details?.file_name}{" "}
                        </a>
                        {item?.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(
                                item?.file_details?.file_path,
                                item?.file_details?.file_name,
                              )
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="col-lg-2 col-md-0 col-sm-0 d-flex justify-content-center">
            <div
              className="vertical-line"
              style={{
                width: "1px",
                height: "100%",
                backgroundColor: "#cfcccc",
              }}
            ></div>
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {shareholdings
              .slice(Math.ceil(shareholdings?.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex justify-content-start">
                    <p
                      className={`mb-0 para ${styles.date}`}
                      style={{ lineHeight: "30px" }}
                    >
                      {item?.file_details?.file_title} :
                    </p>
                  </div>
                  <div className="d-flex align-items-center">
                    <Icon name="pdfIcon" width="20px" />
                    <div>
                      <div
                        className={`blueText para mb-0  ${styles.contentText}`}
                      >
                        <a
                          href={item?.file_details?.file_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item?.file_details?.file_name}{" "}
                        </a>
                        {item?.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(
                                item?.file_details?.file_path,
                                item?.file_details?.file_name,
                              )
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>

          <div className="col-12 d-flex align-items-center justify-content-center">
            <div className="mt-3">
              <button
                className={`secondary-btn ${styles.moreButton}`}
                onClick={handleShareholdingMoreClick}
              >
                More
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const ConferencesData = ({
  conferences,
  downloadFile,
  handleconferencesMoreClick,
}) => {
  return (
    <div>
      {conferences && conferences?.length > 0 && (
        <div className={`row ${styles.divBorder}`}>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {conferences
              .slice(0, Math.ceil(conferences?.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <p
                    className={`para mb-3 ${styles.contentText} ${styles.date}`}
                    style={{ color: "#000000" }}
                  >
                    <strong>{item?.title}</strong>
                  </p>
                  {/* Q1 data */}
                  {item?.q1_contents?.length > 0 && (
                    <div className="mb-3">
                      <p
                        className={`para mb-1 ${styles.contentText} ${styles.date}`}
                        style={{ color: "#000000" }}
                      >
                        <strong>Q1</strong>
                      </p>
                      <>
                        {item.q1_contents?.map((item, index) => (
                          <div key={index}>
                            {["mp3", "m4a"].includes(item.file_type) && (
                              <div className="d-flex align-items-center">
                                <Icon name="audioIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0 ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                            {item.file_type === "pdf" && (
                              <div className="d-flex align-items-center">
                                <Icon name="pdfIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0 ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}
                                    </a>

                                    {item.is_download === 1 && (
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          downloadFile(
                                            item?.file_path,
                                            item.file_name,
                                          )
                                        }
                                      >
                                        <Icon name="circleDownArrow" />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                            {item.file_type === "mp4" && (
                              <div className="d-flex align-items-center">
                                <Icon name="videoCall" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0 ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </>
                    </div>
                  )}
                  {/* Q2 data */}
                  {item?.q2_contents?.length > 0 && (
                    <div className="mb-3">
                      <p
                        className={`para mb-1 ${styles.contentText} ${styles.date}`}
                        style={{ color: "#000000" }}
                      >
                        <strong>Q2</strong>
                      </p>
                      <>
                        {item.q2_contents?.map((item, index) => (
                          <div key={index}>
                            {["mp3", "m4a"].includes(item.file_type) && (
                              <div className="d-flex align-items-center">
                                <Icon name="audioIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0 ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                            {item.file_type === "pdf" && (
                              <div className="d-flex align-items-center">
                                <Icon name="pdfIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0 ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}
                                    </a>

                                    {item.is_download === 1 && (
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          downloadFile(
                                            item?.file_path,
                                            item.file_name,
                                          )
                                        }
                                      >
                                        <Icon name="circleDownArrow" />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                            {item.file_type === "mp4" && (
                              <div className="d-flex align-items-center">
                                <Icon name="videoCall" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0 ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </>
                    </div>
                  )}
                  {/* Q3 data */}
                  {item?.q3_contents?.length > 0 && (
                    <div className="mb-3">
                      <p
                        className={`para mb-1 ${styles.contentText} ${styles.date}`}
                        style={{ color: "#000000" }}
                      >
                        <strong>Q3</strong>
                      </p>
                      <>
                        {item.q3_contents?.map((item, index) => (
                          <div key={index}>
                            {["mp3", "m4a"].includes(item.file_type) && (
                              <div className="d-flex align-items-center">
                                <Icon name="audioIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0 ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                            {item.file_type === "pdf" && (
                              <div className="d-flex align-items-center">
                                <Icon name="pdfIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0 ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}
                                    </a>

                                    {item.is_download === 1 && (
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          downloadFile(
                                            item?.file_path,
                                            item.file_name,
                                          )
                                        }
                                      >
                                        <Icon name="circleDownArrow" />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                            {item.file_type === "mp4" && (
                              <div className="d-flex align-items-center">
                                <Icon name="videoCall" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0 ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </>
                    </div>
                  )}
                  {/* Q4 data */}
                  {item?.q4_contents?.length > 0 && (
                    <div className="mb-3">
                      <p
                        className={`para mb-1 ${styles.contentText} ${styles.date}`}
                        style={{ color: "#000000" }}
                      >
                        <strong>Q4</strong>
                      </p>
                      <>
                        {item.q4_contents?.map((item, index) => (
                          <div key={index}>
                            {["mp3", "m4a"].includes(item.file_type) && (
                              <div className="d-flex align-items-center">
                                <Icon name="audioIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0 ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                            {item.file_type === "pdf" && (
                              <div className="d-flex align-items-center">
                                <Icon name="pdfIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0 ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}
                                    </a>

                                    {item.is_download === 1 && (
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          downloadFile(
                                            item?.file_path,
                                            item.file_name,
                                          )
                                        }
                                      >
                                        <Icon name="circleDownArrow" />
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            )}
                            {item.file_type === "mp4" && (
                              <div className="d-flex align-items-center">
                                <Icon name="videoCall" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0 ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </>
                    </div>
                  )}
                </div>
              ))}
          </div>
          <div className="col-lg-2 col-md-0 col-sm-0 d-flex justify-content-center">
            <div
              className="vertical-line"
              style={{
                width: "1px",
                height: "100%",
                backgroundColor: "#cfcccc",
              }}
            ></div>
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {conferences
              .slice(Math.ceil(conferences.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <p
                    className={`para mb-3 ${styles.contentText} ${styles.date}`}
                    style={{ color: "#000000" }}
                  >
                    <strong>{item?.title}</strong>
                  </p>
                  {/* Q1 data */}
                  {item?.q1_contents?.length > 0 && (
                    <div className="mb-3">
                      <p
                        className={`para mb-1 ${styles.contentText} ${styles.date}`}
                        style={{ color: "#000000" }}
                      >
                        <strong>Q1</strong>
                      </p>
                      <>
                        {item.q1_contents?.map((item, index) => (
                          <div key={index}>
                            {item.file_type === "mp3" && (
                              <div className="d-flex align-items-center">
                                <Icon name="audioIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0  ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}{" "}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}

                            {item.file_type === "pdf" && (
                              <div className="d-flex align-items-center">
                                <Icon name="pdfIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0  ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}{" "}
                                    </a>
                                    {item.is_download === 1 && (
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          downloadFile(
                                            item?.file_path,
                                            item.file_name,
                                          )
                                        }
                                      >
                                        <Icon name="circleDownArrow" />
                                      </span>
                                    )}{" "}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </>
                    </div>
                  )}
                  {/* Q2 data */}
                  {item?.q2_contents?.length > 0 && (
                    <div className="mb-3">
                      <p
                        className={`para mb-1 ${styles.contentText} ${styles.date}`}
                        style={{ color: "#000000" }}
                      >
                        <strong>Q2</strong>
                      </p>
                      <>
                        {item.q2_contents?.map((item, index) => (
                          <div key={index}>
                            {item.file_type === "mp3" && (
                              <div className="d-flex align-items-center">
                                <Icon name="audioIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0  ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}{" "}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                            {item.file_type === "pdf" && (
                              <div className="d-flex align-items-center">
                                <Icon name="pdfIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0  ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}{" "}
                                    </a>
                                    {item.is_download === 1 && (
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          downloadFile(
                                            item?.file_path,
                                            item.file_name,
                                          )
                                        }
                                      >
                                        <Icon name="circleDownArrow" />
                                      </span>
                                    )}{" "}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </>
                    </div>
                  )}
                  {/* Q3 data */}
                  {item?.q3_contents?.length > 0 && (
                    <div className="mb-3">
                      <p
                        className={`para mb-1 ${styles.contentText} ${styles.date}`}
                        style={{ color: "#000000" }}
                      >
                        <strong>Q3</strong>
                      </p>
                      <>
                        {item.q3_contents?.map((item, index) => (
                          <div key={index}>
                            {item.file_type === "mp3" && (
                              <div className="d-flex align-items-center">
                                <Icon name="audioIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0  ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}{" "}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                            {item.file_type === "pdf" && (
                              <div className="d-flex align-items-center">
                                <Icon name="pdfIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0  ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}{" "}
                                    </a>
                                    {item.is_download === 1 && (
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          downloadFile(
                                            item?.file_path,
                                            item.file_name,
                                          )
                                        }
                                      >
                                        <Icon name="circleDownArrow" />
                                      </span>
                                    )}{" "}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </>
                    </div>
                  )}
                  {/* Q4 data */}
                  {item?.q4_contents?.length > 0 && (
                    <div className="mb-3">
                      <p
                        className={`para mb-1 ${styles.contentText} ${styles.date}`}
                        style={{ color: "#000000" }}
                      >
                        <strong>Q4</strong>
                      </p>
                      <>
                        {item.q4_contents?.map((item, index) => (
                          <div key={index}>
                            {item.file_type === "mp3" && (
                              <div className="d-flex align-items-center">
                                <Icon name="audioIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0  ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}{" "}
                                    </a>
                                  </div>
                                </div>
                              </div>
                            )}
                            {item.file_type === "pdf" && (
                              <div className="d-flex align-items-center">
                                <Icon name="pdfIcon" width="20px" />
                                <div>
                                  <div
                                    className={`blueText para mb-0  ${styles.contentText}`}
                                  >
                                    <a
                                      href={item?.file_path}
                                      style={{
                                        color: "#DB6516",
                                        textDecoration: "none",
                                      }}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {item?.file_title}{" "}
                                    </a>
                                    {item.is_download === 1 && (
                                      <span
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          downloadFile(
                                            item?.file_path,
                                            item.file_name,
                                          )
                                        }
                                      >
                                        <Icon name="circleDownArrow" />
                                      </span>
                                    )}{" "}
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        ))}
                      </>
                    </div>
                  )}
                </div>
              ))}
          </div>

          <div className="col-12 d-flex align-items-center justify-content-center">
            <div className="mt-3">
              <button
                className={`secondary-btn ${styles.moreButton}`}
                onClick={handleconferencesMoreClick}
              >
                More
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const PresentationsData = ({
  presentations,
  downloadFile,
  handlePresentationMoreClick,
}) => {
  return (
    <div>
      {presentations && presentations?.length > 0 && (
        <div className={`row ${styles.divBorder}`}>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {presentations
              .slice(0, Math.ceil(presentations.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex justify-content-start align-items-start">
                    <div style={{ width: "20px" }} className="">
                      <Icon name="pdfIcon" width="20px" />
                    </div>
                    <div>
                      <div
                        className={`blueText para mb-0  ${styles.contentText}`}
                      >
                        <a
                          href={item.document_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.title}{" "}
                        </a>
                        {item.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(item.document_path, item.title)
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-start">
                    <p className={`mb-0 ${styles.date}`}>
                      {" "}
                      {formatDate(item.publish_date)}
                    </p>
                  </div>
                </div>
              ))}
          </div>
          <div className="col-lg-2 col-md-0 col-sm-0 d-flex justify-content-center">
            <div
              className="vertical-line"
              style={{
                width: "1px",
                height: "100%",
                backgroundColor: "#cfcccc",
              }}
            ></div>
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {presentations
              .slice(Math.ceil(presentations.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex align-items-center">
                    <Icon name="pdfIcon" width="20px" />
                    <div>
                      <div
                        className={`blueText para mb-0  ${styles.contentText}`}
                      >
                        <a
                          href={item.document_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.title}{" "}
                        </a>
                        {item.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(item.document_path, item.title)
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-start">
                    <p className={`mb-0 ${styles.date}`}>
                      {" "}
                      {formatDate(item?.publish_date)}
                    </p>
                  </div>
                </div>
              ))}
          </div>

          <div className="col-12 d-flex align-items-center justify-content-center">
            <div className="mt-3">
              <button
                className={`secondary-btn ${styles.moreButton}`}
                onClick={handlePresentationMoreClick}
              >
                More
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const StockExchangesData = ({
  stocks,
  downloadFile,
  handleStocksMoreClick,
}) => {
  return (
    <div>
      {stocks && stocks?.length > 0 && (
        <div className={`row ${styles.divBorder}`}>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {stocks
              .slice(0, Math.ceil(stocks.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex justify-content-start align-items-start">
                    <div style={{ width: "20px" }} className="">
                      <Icon name="pdfIcon" width="20px" />
                    </div>
                    <div>
                      <div
                        className={`blueText para mb-0  ${styles.contentText}`}
                      >
                        <a
                          href={item.document_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.title}{" "}
                        </a>
                        {item.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(item.document_path, item.title)
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-start">
                    <p className={`mb-0 ${styles.date}`}>
                      {formatDate(item?.publish_date)}
                    </p>
                  </div>
                </div>
              ))}
          </div>
          <div className="col-lg-2 col-md-0 col-sm-0 d-flex justify-content-center">
            <div
              className="vertical-line"
              style={{
                width: "1px",
                height: "100%",
                backgroundColor: "#cfcccc",
              }}
            ></div>
          </div>
          <div className="col-lg-5 col-md-12 col-md-12">
            {stocks.slice(Math.ceil(stocks.length / 2)).map((item, index) => (
              <div className="pb-4" key={index}>
                <div className="d-flex justify-content-start align-items-start">
                  <div style={{ width: "20px" }} className="">
                    <Icon name="pdfIcon" width="20px" />
                  </div>
                  <div>
                    <div
                      className={`blueText para mb-0  ${styles.contentText}`}
                    >
                      <a
                        href={item.document_path}
                        style={{
                          color: "#DB6516",
                          textDecoration: "none",
                          cursor: "pointer",
                        }}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {item.title}{" "}
                      </a>
                      {item.is_download === 1 && (
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            downloadFile(item.document_path, item.title)
                          }
                        >
                          <Icon name="circleDownArrow" />
                        </span>
                      )}{" "}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-start">
                  <p className={`mb-0 ${styles.date}`}>
                    {formatDate(item?.publish_date)}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="col-12 d-flex align-items-center justify-content-center">
            <div className="mt-3">
              <button
                className={`secondary-btn ${styles.moreButton}`}
                onClick={handleStocksMoreClick}
              >
                More
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export const ConductData = ({
  conducts,
  downloadFile,
  handleConductsMoreClick,
}) => {
  return (
    <div>
      {conducts && conducts?.length > 0 && (
        <div className={`row ${styles.divBorder}`}>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {conducts
              .slice(0, Math.ceil(conducts.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex justify-content-start align-items-start">
                    <div style={{ width: "20px" }} className="">
                      <Icon name="pdfIcon" width="20px" />
                    </div>
                    <div>
                      <div
                        className={`blueText para mb-0 ${styles.contentText}`}
                      >
                        <a
                          href={item.document_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.title}{" "}
                        </a>
                        {item.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(item.document_path, item.title)
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="col-lg-2 col-md-0 col-sm-0 d-flex justify-content-center">
            <div
              className="vertical-line"
              style={{
                width: "1px",
                height: "100%",
                backgroundColor: "#cfcccc",
              }}
            ></div>
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {conducts
              .slice(Math.ceil(conducts.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex justify-content-start align-items-start">
                    <div style={{ width: "20px" }} className="">
                      <Icon name="pdfIcon" width="20px" />
                    </div>
                    <div>
                      <div
                        className={`blueText para mb-0 ${styles.contentText}`}
                      >
                        <a
                          href={item.document_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.title}{" "}
                        </a>
                        {item.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(item.document_path, item.title)
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>

          {/* <div className="col-12 d-flex align-items-center justify-content-center">
            <div className="mt-3">
              <button
                className={`secondary-btn ${styles.moreButton}`}
                onClick={handleConductsMoreClick}
              >
                More
              </button>
            </div>
          </div> */}
        </div>
      )}
    </div>
  );
};

export const BoardData = ({ redirectToBoardPage }) => {
  return (
    <div>
      <p
        className={`para ${styles.contentText}`}
        style={{ cursor: "pointer" }}
        onClick={() => redirectToBoardPage()}
      >
        Board of Directors
      </p>
    </div>
  );
};

export const PoliciesData = ({
  policies,
  downloadFile,
  handlePliciesMoreClick,
}) => {
  return (
    <div>
      {policies && policies?.length > 0 && (
        <div className={`row ${styles.divBorder}`}>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {policies
              .slice(0, Math.ceil(policies.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex align-items-center">
                    <Icon name="pdfIcon" width="20px" />
                    <div>
                      <div
                        className={`blueText para mb-0  ${styles.contentText}`}
                      >
                        <a
                          href={item?.document_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.title}{" "}
                        </a>
                        {item.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(item.document_path, item.title)
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
          <div className="col-lg-2 col-md-0 col-sm-0 d-flex justify-content-center">
            <div
              className="vertical-line"
              style={{
                width: "1px",
                height: "100%",
                backgroundColor: "#cfcccc",
              }}
            ></div>
          </div>
          <div className="col-lg-5 col-md-12 col-sm-12">
            {policies
              .slice(Math.ceil(policies.length / 2))
              .map((item, index) => (
                <div className="pb-4" key={index}>
                  <div className="d-flex align-items-center">
                    <Icon name="pdfIcon" width="20px" />
                    <div>
                      <div
                        className={`blueText para mb-0  ${styles.contentText}`}
                      >
                        <a
                          href={item.document_path}
                          style={{
                            color: "#DB6516",
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.title}{" "}
                        </a>
                        {item.is_download === 1 && (
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              downloadFile(item.document_path, item.title)
                            }
                          >
                            <Icon name="circleDownArrow" />
                          </span>
                        )}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>

          {/* <div className="col-12 d-flex align-items-center justify-content-center">
            <div className="mt-3">
              <button
                className={`secondary-btn ${styles.moreButton}`}
                onClick={handlePliciesMoreClick}
              >
                More
              </button>
            </div>
          </div> */}
        </div>
      )}
    </div>
  );
};
